import { render, staticRenderFns } from "./Parametres.vue?vue&type=template&id=3ad83540&"
import script from "./Parametres.vue?vue&type=script&lang=js&"
export * from "./Parametres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad83540')) {
      api.createRecord('3ad83540', component.options)
    } else {
      api.reload('3ad83540', component.options)
    }
    module.hot.accept("./Parametres.vue?vue&type=template&id=3ad83540&", function () {
      api.rerender('3ad83540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/Parametres.vue"
export default component.exports